var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0058 19.0075H10.0037C5.03112 19.0075 1 14.9764 1 10.0037C1 5.03112 5.03112 1 10.0037 1C14.9764 1 19.0075 5.03112 19.0075 10.0037V11.5044C19.0075 12.8857 17.8877 14.0054 16.5065 14.0054C15.1252 14.0054 14.0054 12.8857 14.0054 11.5044V10.0037C14.0054 7.79369 12.2138 6.00208 10.0037 6.00208V6.00208C7.79369 6.00208 6.00208 7.79369 6.00208 10.0037C6.00208 12.2138 7.79369 14.0054 10.0037 14.0054C12.2138 14.0054 14.0054 12.2138 14.0054 10.0037",
    stroke: "#7660FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/@Icon.65a540a2a3638388626b5bdffc2e6680.svg";
export { ForwardRef as ReactComponent };